var _circle, _circle2, _path, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreProductFilmOverviewPlayControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FleetCore product film play control") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 78,
    fill: "#020716",
    fillOpacity: 0.82,
    stroke: "#80C4FF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 62,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 3,
    strokeDasharray: "260 130",
    transform: "rotate(-40 90 90)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 62 124 90 77 118Z",
    fill: "#FFFFFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 85,
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2,
    strokeDasharray: "38 500",
    transform: "rotate(22 90 90)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreProductFilmOverviewPlayControl);
export default __webpack_public_path__ + "static/media/fleetcore-product-film-overview-play-control.097ec4f9b9d19546b4e8b4cd9e8272f0.svg";
export { ForwardRef as ReactComponent };